import styled from "styled-components";

interface DialogPortalOverlayProps {
  $zIndex?: string;
}

export const DialogPortalOverlay = styled.div<DialogPortalOverlayProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: ${(props) => props.$zIndex ?? "10000"};
  background: var(--modal-background);
  display: flex;
  justify-content: center;
  align-items: center;
  /* pointer-events: none; */
`;
